import { Form, DatePicker, TimePicker, Button, Space, message, Modal, Input, InputNumber, Typography, Row, Col, Table } from "antd";
import { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../../../../layout/auth";
import moment from "moment";
import "moment/locale/es";
moment.locale("es-mx");

export default function AddVisitForm(props) {
  const { id, setVisits, formVisibility, setFormVisibility, timeRange, verification } = props;

  const [form] = Form.useForm();
  const auth = useAuth();
  const [dateSelection, setDateSelection] = useState(null);
  const [visitHistory, setVisitHistory] = useState([]);
  const [selectedVisit, setSelectedVisit] = useState(null);
  const [previewVisit, setPreviewVisit] = useState(null);
  const [previousVisit, setPreviousVisit] = useState(null);
  const [distancia, setDistancia] = useState(null);
  const [detallesTrayecto, setDetallesTrayecto] = useState({
    distancia: 0,
    horaInicio: "",
    horaFin: "",
    duracionMinutos: 0,
    velocidadKmH: 0,
  });
  const [hora1, setHora1] = useState(null); // State for Hora1
  const [hora2, setHora2] = useState(null); // State for Hora2

  const startTime = timeRange[0]?.HoraInicio ? moment(timeRange[0]?.HoraInicio, "HH:mm:ss").hour() : null;
  const endTime = timeRange[0]?.HoraFin ? moment(timeRange[0]?.HoraFin, "HH:mm:ss").hour() : null;

  // Disable times before HoraInicio and after HoraFin for Hora1
  const disabledTimeHora1 = () => {
    return {
      disabledHours: () => {
        const disabledHours = [];

        // Disable all hours before HoraInicio
        for (let hour = 0; hour < startTime; hour++) {
          disabledHours.push(hour);
        }

        // Disable all hours after HoraFin
        for (let hour = endTime; hour < 24; hour++) {
          disabledHours.push(hour);
        }

        // If Hora2 is set, disable all hours later than it
        if (hora2 !== null) {
          const selectedHora2 = moment(hora2, "HH:mm:ss").hour();
          for (let hour = selectedHora2 + 1; hour < 24; hour++) {
            disabledHours.push(hour);
          }
        }

        return disabledHours;
      },
      disabledMinutes: (selectedHour) => {
        const disabledMinutes = [];

        // If Hora1 is set, disable minutes greater than the selected HoraInicio minute
        if (hora1 !== null && moment(hora1, "HH:mm:ss").hour() === selectedHour) {
          const selectedMinute = moment(hora1, "HH:mm:ss").minute();

          // Disable minutes greater than selectedHora1 minute
          for (let minute = selectedMinute + 1; minute < 60; minute++) {
            disabledMinutes.push(minute);
          }
        }

        // If Hora2 is set, disable minutes after it
        if (hora2 !== null && moment(hora2, "HH:mm:ss").hour() === selectedHour) {
          const selectedMinute = moment(hora2, "HH:mm:ss").minute();

          // Disable minutes after the selected HoraTermino minute
          for (let minute = selectedMinute + 1; minute < 60; minute++) {
            disabledMinutes.push(minute);
          }
        }

        return disabledMinutes;
      },
    };
  };

  // Disable times before HoraInicio, after HoraFin, and based on selected time for Hora2
  const disabledTimeHora2 = () => {
    return {
      disabledHours: () => {
        const disabledHours = [];

        // Disable all hours before HoraInicio
        for (let hour = 0; hour < startTime; hour++) {
          disabledHours.push(hour);
        }

        // Disable all hours after HoraFin
        for (let hour = endTime; hour < 24; hour++) {
          disabledHours.push(hour);
        }

        // If Hora1 is set, disable all hours earlier than it
        if (hora1 !== null) {
          const selectedHora1 = moment(hora1, "HH:mm:ss").hour();
          for (let hour = 0; hour < selectedHora1; hour++) {
            disabledHours.push(hour);
          }
        }

        return disabledHours;
      },
      disabledMinutes: (selectedHour) => {
        const disabledMinutes = [];

        // If Hora2 is set, disable minutes greater than the selected HoraTermino minute
        if (hora2 !== null && moment(hora2, "HH:mm:ss").hour() === selectedHour) {
          const selectedMinute = moment(hora2, "HH:mm:ss").minute();

          // Disable minutes greater than the selected HoraTermino minute
          for (let minute = selectedMinute + 1; minute < 60; minute++) {
            disabledMinutes.push(minute);
          }
        }

        // If Hora1 is set, disable minutes before it
        if (hora1 !== null && moment(hora1, "HH:mm:ss").hour() === selectedHour) {
          const selectedMinute = moment(hora1, "HH:mm:ss").minute();

          // Disable minutes before the selected HoraInicio minute
          for (let minute = 0; minute < selectedMinute; minute++) {
            disabledMinutes.push(minute);
          }
        }

        return disabledMinutes;
      },
    };
  };

  const disabledDates = () => {
    const today = moment(); // Get today's date
    const startDate = today.clone().subtract(timeRange[0]?.DiasAntes || 0, "days"); // Calculate the start date (today - DiasAntes days)
    const endDate = today.clone().add(timeRange[0]?.DiasDespues || 0, "days"); // Calculate the end date (today + DiasDespues days)
    return (currentDate) => {
      // Disable dates before the start date and after the end date
      return currentDate.isBefore(startDate, "day") || currentDate.isAfter(endDate, "day");
    };
  };

  useEffect(() => {
    if (formVisibility) {
      form.resetFields();
      setDateSelection(null);
      setVisitHistory([]);
      setPreviewVisit(null);
      setSelectedVisit(null);
      setPreviousVisit(null);
      setDistancia(null);
      setDetallesTrayecto(null);
      setHora1(null);
      setHora2(null);
    }
  }, [formVisibility, form]);

  useEffect(() => {
    if (dateSelection || previewVisit) {
      const d1 = moment(dateSelection, "DD/MM/YYYY").subtract(1, "days").format("YYYY-MM-DD");
      const d2 = moment(dateSelection, "DD/MM/YYYY").add(1, "days").format("YYYY-MM-DD");

      axios
        .get(`${process.env.REACT_APP_API_URL}/visitas?u=${auth.UID}&d1=${d1}&d2=${d2}`)
        .then((res) => {
          // Merge the preview visit into the fetched visit history
          const mergedHistory = res.data.filter((visit) => visit.ControlInterno !== "Nueva visita");

          if (previewVisit) {
            mergedHistory.push(previewVisit);
          }

          // Sort the list
          const sortedHistory = mergedHistory.sort((a, b) => {
            const timeA = moment(`${a.FechaVisita} ${a.HoraInicio}`, "YYYY-MM-DD HH:mm:ss").valueOf();
            const timeB = moment(`${b.FechaVisita} ${b.HoraInicio}`, "YYYY-MM-DD HH:mm:ss").valueOf();
            return timeA - timeB;
          });

          // Find the "new visit" and the previous visit
          const newVisitIndex = sortedHistory.findIndex((visit) => visit.ControlInterno === "Nueva visita");
          const prevVisit = newVisitIndex > 0 ? sortedHistory[newVisitIndex - 1] : null;

          // Set the previous visit and log the result
          if (prevVisit) {
            setPreviousVisit(prevVisit);
          } else {
            console.log("No previous visit found");
          }

          setVisitHistory(sortedHistory);
        })
        .catch((err) => {
          console.log("Error al obtener las visitas", err);
          message.error("Error al obtener las visitas");
        });
    }
  }, [dateSelection, previewVisit, auth.UID]);

  const handleFormChange = (_, allValues) => {
    const { FechaVisita, HoraInicio, HoraTermino } = allValues;

    if (FechaVisita && HoraInicio) {
      const newVisit = {
        ControlInterno: "Nueva visita",
        FechaVisita: moment(FechaVisita).format("YYYY-MM-DD"),
        HoraInicio: moment(HoraInicio, "HH:mm").format("HH:mm:ss"),
        HoraTermino: HoraTermino ? moment(HoraTermino, "HH:mm").format("HH:mm:ss") : "",
        ColoniaOAsentamiento: verification?.ColoniaOAsentamiento,
        Municipio: verification?.Municipio,
        Estado: verification?.Estado,
      };

      setPreviewVisit(newVisit);
    } else {
      setPreviewVisit(null); // Remove preview visit if the form is incomplete
    }
  };

  useEffect(() => {
    if (previousVisit) {
      let locationString = "Ubicación desconocida";

      if (previousVisit.Estado) {
        if (previousVisit.Municipio) {
          if (previousVisit.ColoniaOAsentamiento) {
            locationString = `${previousVisit.ColoniaOAsentamiento}, ${previousVisit.Municipio}, ${previousVisit.Estado}`;
          } else {
            locationString = `${previousVisit.Municipio}, ${previousVisit.Estado}`;
          }
        } else {
          locationString = previousVisit.Estado;
        }
      }

      form.setFieldsValue({
        // UbicacionOrigen: locationString,
      });
    }
  }, [previousVisit, form]);

  // Update visitHistory only when selectedVisit changes (still needed for the fake visit functionality)
  useEffect(() => {
    if (selectedVisit) {
      setVisitHistory((prev) => {
        const filteredVisits = prev.filter((visit) => visit.ControlInterno !== "Nueva visita");

        const updatedList = [...filteredVisits, selectedVisit].sort((a, b) => {
          const timeA = moment(`${a.FechaVisita} ${a.HoraInicio}`, "YYYY-MM-DD HH:mm:ss").valueOf();
          const timeB = moment(`${b.FechaVisita} ${b.HoraInicio}`, "YYYY-MM-DD HH:mm:ss").valueOf();
          return timeA - timeB;
        });

        return updatedList;
      });
    }
  }, [selectedVisit]);

  const handleDistanciaChange = (value) => {
    setDistancia(value);
  };

  useEffect(() => {
    if (previousVisit && previewVisit && distancia) {
      // Calculate the start and end times using moment.js
      // console.log("Previous Visit HoraTermino:", previousVisit.HoraTermino);
      // console.log("New Visit HoraInicio:", previewVisit.HoraInicio);

      const dateTime1 = moment(`${previousVisit.FechaVisita} ${previousVisit.HoraTermino}`, "YYYY-MM-DD HH:mm:ss");
      const dateTime2 = moment(`${previewVisit.FechaVisita} ${previewVisit.HoraInicio}`, "YYYY-MM-DD HH:mm:ss");

      if (dateTime1.isValid() && dateTime2.isValid()) {
        // Duration between the visits
        const momentDuration = moment.duration(dateTime2.diff(dateTime1));

        // Calculate the speed (in Km/h) and duration (in minutes)
        const durationMinutes = momentDuration.asMinutes();
        const speedKmH = distancia / momentDuration.asHours();

        // Update the state with the calculated values
        setDetallesTrayecto({
          distancia,
          horaInicio: previewVisit.HoraInicio,
          horaFin: previewVisit.HoraTermino,
          duracionMinutos: durationMinutes,
          velocidadKmH: speedKmH,
        });
      }
    }
  }, [previousVisit, previewVisit, distancia]);

  const trayectoMessage = () => {
    if (detallesTrayecto?.velocidadKmH > 0) {
      const distance = detallesTrayecto.distancia;
      const duration = detallesTrayecto.duracionMinutos;
      //   const actualSpeed = detallesTrayecto.velocidadKmH;

      let travelType = "";
      let message = [];

      // Determine the travel type based on distance
      if (distance < 40) {
        travelType = "ciudad";
      } else if (distance < 120) {
        travelType = "autopista";
      } else {
        travelType = "avión";
      }

      // City travel message
      if (travelType === "ciudad") {
        const averageSpeed = 25; // Average city speed in km/h
        const maxDistance = (duration / 60) * averageSpeed; // Expected distance in city travel
        if (distance > maxDistance) {
          message.push(
            <div>
              <p>
                Por la distancia de <strong>{distance} km</strong>, parece ser un viaje en {travelType}. La velocidad promedio en ciudad
                suele rondar los <strong>25 km/h</strong> con tráfico normal, por lo que en una duración de{" "}
                <strong>{duration} minutos</strong>, deberías poder recorrer <strong>{maxDistance.toFixed(2)} km</strong>, tu distancia es
                de <strong>{distance} km</strong>, por lo tanto parece{" "}
                <span style={{ color: "darkred", fontWeight: "bold", textTransform: "uppercase" }}>irracional ❌</span>.
              </p>
            </div>
          );
        } else {
          message.push(
            <div>
              <p>
                Por la distancia de <strong>{distance} km</strong>, parece ser un viaje en {travelType}. La velocidad promedio en ciudad
                suele rondar los <strong>25 km/h</strong> con tráfico normal, por lo que en una duración de{" "}
                <strong>{duration} minutos</strong>, deberías poder recorrer <strong>{maxDistance.toFixed(2)} km</strong>, tu distancia es
                de <strong>{distance} km</strong>, por lo tanto parece{" "}
                <span style={{ color: "darkgreen", fontWeight: "bold", textTransform: "uppercase" }}>racional ✅</span>.
              </p>
            </div>
          );
        }
      }
      // Highway travel message
      else if (travelType === "autopista") {
        const averageSpeed = 75; // Average highway speed in km/h
        const maxDistance = (duration / 60) * averageSpeed; // Expected distance on highway
        if (distance > maxDistance) {
          message.push(
            <div>
              <p>
                Por la distancia de <strong>{distance} km</strong>, parece ser un viaje en {travelType}. La velocidad promedio en autopista
                suele rondar los <strong>75 km/h</strong> sin atascos, por lo que en una duración de <strong>{duration} minutos</strong>,
                deberías poder recorrer <strong>{maxDistance.toFixed(2)} km</strong>, tu distancia es de <strong>{distance} km</strong>, por
                lo tanto parece <span style={{ color: "darkred", fontWeight: "bold", textTransform: "uppercase" }}>irracional ❌</span>.
              </p>
            </div>
          );
        } else {
          message.push(
            <div>
              <p>
                Por la distancia de <strong>{distance} km</strong>, parece ser un viaje en {travelType}. La velocidad promedio en autopista
                suele rondar los <strong>75 km/h</strong> sin atascos, por lo que en una duración de <strong>{duration} minutos</strong>,
                deberías poder recorrer <strong>{maxDistance.toFixed(2)} km</strong>, tu distancia es de <strong>{distance} km</strong>, por
                lo tanto parece <span style={{ color: "darkgreen", fontWeight: "bold", textTransform: "uppercase" }}>racional ✅</span>.
              </p>
            </div>
          );
        }
      }
      // Flight travel message
      else {
        const airportTime = 120; // Minimum 2 hours for airport time
        const availableTime = duration - airportTime; // Time left for flight travel
        const expectedDistance = (availableTime / 60) * 750; // Expected distance in flight
        if (distance > expectedDistance) {
          message.push(
            <div>
              <p>
                Por la distancia de <strong>{distance} km</strong>, parece ser un viaje en {travelType}. En avión necesitas al menos 2 horas
                en el aeropuerto, con una duración de <strong>{duration} minutos</strong>, te quedan <strong>{availableTime}</strong>{" "}
                minutos para recorrer en el avión, en ese tiempo deberías poder recorrer <strong>{expectedDistance.toFixed(2)} km</strong> a
                una velocidad promedio de <strong>750 km/h</strong>, tu distancia es de <strong>{distance} km</strong>, por lo que parece{" "}
                <span style={{ color: "darkred", fontWeight: "bold", textTransform: "uppercase" }}>irracional ❌</span>.
              </p>
            </div>
          );
        } else {
          message.push(
            <div>
              <p>
                Por la distancia de <strong>{distance} km</strong>, parece ser un viaje en {travelType}. En avión necesitas al menos 2 horas
                en el aeropuerto, con una duración de <strong>{duration} minutos</strong>, te quedan <strong>{availableTime}</strong>{" "}
                minutos para recorrer en el avión, en ese tiempo deberías poder recorrer <strong>{expectedDistance.toFixed(2)} km</strong> a
                una velocidad promedio de <strong>750 km/h</strong>, tu distancia es de <strong>{distance} km</strong>, por lo que parece{" "}
                <span style={{ color: "darkgreen", fontWeight: "bold", textTransform: "uppercase" }}>racional ✅</span>.
              </p>
            </div>
          );
        }
      }

      return message;
    } else {
      return <div>No se pueden calcular los detalles del trayecto sin la información de duración y velocidad.</div>;
    }
  };

  const columns = [
    {
      title: "ControlInterno",
      dataIndex: "ControlInterno",
      key: "ControlInterno",
    },
    {
      title: "Fecha",
      dataIndex: "FechaVisita",
      key: "FechaVisita",
      render: (text) => {
        // text is a datetime stamp
        const parsedRecordVisitDate = moment(text, "YYYY-MM-DD").format("DD/MM/YYYY");
        return <span>{parsedRecordVisitDate}</span>;
      },
    },
    {
      title: "Hora Inicio",
      dataIndex: "HoraInicio",
      key: "HoraInicio",
      render: (text, record) => {
        // text is a HH:mm:ss time string
        return <span>{moment(text, "HH:mm:ss").format("HH:mm")}</span>;
      },
    },
    {
      title: "Hora Termino",
      dataIndex: "HoraTermino",
      key: "HoraTermino",
      render: (text, record) => {
        // text is a HH:mm:ss time string
        return <span>{moment(text, "HH:mm:ss").format("HH:mm")}</span>;
      },
    },
    {
      title: "Colonia",
      dataIndex: "ColoniaOAsentamiento",
      key: "ColoniaOAsentamiento",

      render: (text, record) => {
        if (record.ColoniaOAsentamiento) {
          return <span>{record.ColoniaOAsentamiento}</span>;
        } else {
          return <span className="subtle-text">N/D</span>;
        }
      },
    },
    {
      title: "Municipio",
      dataIndex: "Municipio",
      key: "Municipio",
      render: (text, record) => {
        if (record.Municipio) {
          return <span>{`${record.Municipio}`}</span>;
        } else {
          return <span className="subtle-text">N/D</span>;
        }
      },
    },
    {
      title: "Estado",
      dataIndex: "Estado",
      key: "Estado",
      render: (text, record) => {
        if (record.Estado) {
          return <span>{`${record.Estado}`}</span>;
        } else {
          return <span className="subtle-text">N/D</span>;
        }
      },
    },
  ];

  const onSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        axios
          .post(`${process.env.REACT_APP_API_URL}/visitas`, {
            VerificacionID: id,
            FechaVisita: moment(values.FechaVisita).format("YYYY-MM-DD"),
            HoraInicio: moment(values.HoraInicio, "HH:mm:ss").format("HH:mm:ss"),
            HoraTermino: moment(values.HoraTermino, "HH:mm:ss").format("HH:mm:ss"),
            UbicacionOrigen: values.UbicacionOrigen,
            DistanciaOrigenDestino: values.DistanciaOrigenDestino,
          })
          .then((res) => {
            setFormVisibility(false);
            message.success("Visita agregada");
            axios
              .get(`${process.env.REACT_APP_API_URL}/visitas/${id}`)
              .then((res) => {
                setVisits(res.data);
                message.success("Lista de visitas actualizada");
              })
              .catch((err) => {
                console.log("Error al obtener las visitas", err);
                message.error("Error al obtener las visitas");
              });
          })
          .catch((err) => {
            console.log("Error al agregar la visita", err);
            const errorMsg = err.response?.data?.message || "Error al agregar la visita";
            message.error(errorMsg);
          });
      })
      .catch((err) => {
        console.log(err);
        message.error("Error al validar los campos");
      });
  };

  return (
    <>
      <Modal title="Agregar Visita" visible={formVisibility} onCancel={() => setFormVisibility(false)} footer={null} width={900}>
      <Form form={form} layout="vertical" onValuesChange={handleFormChange}>
        <Row gutter={[16, 16]}>
          <Col span={8}>
            <Form.Item name="FechaVisita" label="Fecha de la visita" rules={[{ required: true, message: "Escriba la fecha de la visita" }]}>
              <DatePicker
                format={"DD/MM/YYYY"}
                onChange={(date, dateString) => {
                  setDateSelection(dateString);
                }}
                style={{ width: "100%" }}
                disabledDate={disabledDates()}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="HoraInicio" label="Hora de inicio" rules={[{ required: true, message: "Seleccione la hora" }]}>
              <TimePicker
                format="HH:mm"
                minuteStep={5}
                style={{ width: "100%" }}
                onChange={(time) => setHora1(time ? time.format("HH:mm:ss") : null)}
                disabledTime={disabledTimeHora1}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="HoraTermino" label="Hora de Término" rules={[{ required: true, message: "Seleccione la hora" }]}>
              <TimePicker
                format="HH:mm"
                minuteStep={5}
                style={{ width: "100%" }}
                onChange={(time) => setHora2(time ? time.format("HH:mm:ss") : null)}
                disabledTime={disabledTimeHora2}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={8}>
            <Form.Item name="UbicacionOrigen" label="Origen" rules={[{ required: true, message: "Escriba de dónde sale" }]}>
              <Input placeholder="De dónde sales" style={{ height: "100%" }} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <div style={{ display: "flex", flexDirection: "column", marginBottom: "16px", height: "100%" }}>
              <label style={{ marginBottom: "8px", color: "#1890ff" }}>Destino:</label>
              <Typography.Text
                type="secondary"
                style={{
                  padding: "8px",
                  border: "1px solid #d9d9d9",
                  backgroundColor: "#f5f5f5",
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  height: "32px",
                }}
              >
                {verification.NombreCalle
                  ? `${verification.NombreCalle} ${verification.NumeroOficial || "S/N"}, ${
                      verification.Asentamiento ? `Col. ${verification.Asentamiento}` : verification.Colonia || ""
                    }, ${verification.Ciudad || ""}, ${verification.Estado || ""}`
                  : "Domicilio conocido"}
              </Typography.Text>
            </div>
          </Col>
          <Col span={8}>
            <Form.Item name="DistanciaOrigenDestino" label="Distancia" rules={[{ required: true, message: "Escriba la distancia" }]}>
              <InputNumber min={0} addonAfter="Km" style={{ height: "100%" }} onChange={handleDistanciaChange} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Table
        dataSource={visitHistory}
        columns={columns}
        size="small"
        scroll={{ y: 300 }}
        rowClassName={(record) => {
          return record.ControlInterno === "Nueva visita" ? "fake-visit" : "";
        }}
      />
      <div style={{ marginBottom: "16px" }}>
        <Typography.Title level={5}>Detalles del trayecto:</Typography.Title>
        <Typography.Text type="secondary">{trayectoMessage()}</Typography.Text>
      </div>
      <Space>
        <Button
          type="primary"
          onClick={() => {
            onSubmit();
          }}
        >
          Agregar
        </Button>
        <Button
          type="primary"
          onClick={() => {
            setFormVisibility(false);
            form.resetFields();
          }}
        >
          Cancelar
        </Button>
      </Space>
      </Modal>
    </>
  );
}
